import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/default/loadscreenview", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
